export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nummer"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktionen"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bearbeiten Sie die Informationen zum Collector"])}
}